var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class-list"},[_c('GlobalInfoBar',{attrs:{"title":"渠道账户账单","content":"统计拓展客户的成交订单的抽成数据,每单按订单成交扣除,退款则自动返回,统计数据按选择的查询时间段自动统计"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('From')],1),_c('Table',{ref:"table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }